import React from 'react'
import { asyncReactor } from 'async-reactor'
import moment from 'moment'
import { getSlots, getBookingsFromDay } from '../../services/booking'

function Loader() {
  return <b>Carregando...</b>
}

async function Component({ date }) {
  const itemDate = moment(date).format('YYYY-MM-DD')
  const slots = await getSlots(itemDate)
  const bookings = await getBookingsFromDay(itemDate)

  const response = Array.isArray(slots) ? (
    <span>{`${slots.length - bookings} vagas`}</span>
  ) : (
    <span>...</span>
  )
  return response
}

export default asyncReactor(Component, Loader)
